


import React, { useEffect, useState } from 'react';
import {
  Popover,
  Radio,
  RadioGroup,
  FormControlLabel,
  IconButton
} from '@mui/material';
import { statusOptionsOrder,CustomerTagOptions ,statusOptionsWeekly ,statusCampaign  } from "../../constants/statusOption";

const statusStyles = {
  in_progress: {
    bg: 'bg-[#FDF7DF]',
    text: 'text-[#676C38]',
  },
  recieved: {
    bg: 'bg-[#DFF3FE]',
    text: 'text-[#05729B]',
  },
  out_for_delivery: {
    bg: 'bg-[#FDDFDF]',
    text: 'text-[#754C5D]',
  },
  ready: {
    bg: 'bg-[#F1DEFE]',
    text: 'text-[#5C46A8]',
  },
    open: {
    bg: 'bg-[#E4FDDF]',
    text: 'text-[#0D5E04]',
  },
    closed: {
    bg: 'bg-[#FDDFDF]',
    text: 'text-[#C20101]',
  },
    active: {
    bg: 'bg-[#E4FDDF]',
    text: 'text-[#0D5E04]',
  },
    inactive: {
    bg: 'bg-[#FDDFDF]',
    text: 'text-[#C20101]',
  },
    pause: {
    bg: 'bg-[#DFF3FE]',
    text: 'text-[#05729B]',
  },
    ended: {
    bg: 'bg-[#FDF7DF]',
    text: 'text-[#676C38]',
  },
  vip: {
    bg: 'bg-[#FDF7DF]',
    text: 'text-[#676C38]',
  },
  new: {
    bg: 'bg-[#DFF3FE]',
    text: 'text-[#05729B]',
  },
  at_risk: {
    bg: 'bg-[#FDDFDF]',
    text: 'text-[#C20101]',
  },
  pending:              { bg: 'bg-[#FFF4E5]', text: 'text-[#C27C00]' },      // warm orange
  confirmed:            { bg: 'bg-[#E8F4F1]', text: 'text-[#00796B]' },      // teal
  pickup_scheduled:     { bg: 'bg-[#ECE7F6]', text: 'text-[#5E35B1]' },      // deep purple
  pickup_rescheduled:   { bg: 'bg-[#EDE7F6]', text: 'text-[#6A1B9A]' },      // slightly darker purple
  pickup_confirmed:     { bg: 'bg-[#E0F7FA]', text: 'text-[#007C91]' },      // cyan
  out_for_pickup:       { bg: 'bg-[#FFFDE7]', text: 'text-[#F9A825]' },      // bright yellow
  picked_up:            { bg: 'bg-[#E3F2FD]', text: 'text-[#1565C0]' },      // blue
  at_store:             { bg: 'bg-[#E8F5E9]', text: 'text-[#2E7D32]' },      // green
  processing:           { bg: 'bg-[#F3E5F5]', text: 'text-[#8E24AA]' },      // violet
  delayed:              { bg: 'bg-[#FFEBEE]', text: 'text-[#C62828]' },      // red
  ready_for_delivery:   { bg: 'bg-[#F1F8E9]', text: 'text-[#558B2F]' },      // olive green
  delivered:            { bg: 'bg-[#E8F5E9]', text: 'text-[#2E7D32]' },      // deep green
  default: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
  },
};

const StatusTags = ({ content, onTagChange = () => { },tableName = "",rowData ,canUpdateStatus }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [status, setStatus] = useState(content?.toLowerCase().replace(/\s+/g, '_') || '');
  const { bg, text } = statusStyles[content?.toLowerCase().replace(/\s+/g, '_') || ''] || statusStyles.default;

   useEffect(() => { 
      setStatus(content?.toLowerCase().replace(/\s+/g, '_') || '')
    }, [content]);

  const handleClick = (event) => {
  // if (tableName !== "order management" || canUpdateStatus) {
    setAnchorEl(event.currentTarget);
  // }
};

  const handleClose = () => {
    setAnchorEl(null)
    setStatus("")
  }


  const handleChange = (event) => {
    const newStatus = event.target.value;
    onTagChange(newStatus ,rowData);
    handleClose();
  };

  const getStatusOptions = () => {
  switch (tableName) {
     case "blackout":
    case "weekly-schedule":
      return statusOptionsWeekly;
    case "campaign":
    case "user-management":
      return statusCampaign;
    case "order management":
      return statusOptionsOrder;
    case "customer management":
      return CustomerTagOptions;
    default:
      return statusOptionsOrder;
  }
};
  const options = getStatusOptions();
  return (
    <>
      <div
        onClick={handleClick}
        className={`h-[30px] text-xs min-w-[130px] max-w-[300px] capitalize  px-3 rounded-full font-semibold flex justify-center items-center cursor-pointer ${bg} ${text}`}
      >
        {content?.replace(/_/g, ' ') || ''}
      </div>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          className: 'p-4 ',
          style: { minWidth: '180px' },
        }}
      >
        <RadioGroup value={status} onChange={handleChange}>
          {options.map((option) => {
            const { bg, text } = statusStyles[option?.value?.toLowerCase()] || statusStyles.default;

            return (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={
                  <div
                    className={`flex justify-center items-center h-[30px] min-w-[130px] rounded-full text-xs font-medium ${bg} ${text}`}
                  >
                    {option.label}
                  </div>
                }
                className="mb-2"
              />
            );
          })}
        </RadioGroup>
      </Popover>
    </>
  );
};

export default StatusTags;
